import { render, staticRenderFns } from "./BKMediaEditor.vue?vue&type=template&id=46aac92a&scoped=true"
import script from "./BKMediaEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKMediaEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKMediaEditor.vue?vue&type=style&index=0&id=46aac92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aac92a",
  null
  
)

export default component.exports